import styled from "styled-components";
import { SearcherSkeleton as SearcherSkeletonDefault } from "../../../searcher/skeleton/index.js";
export const SearcherSkeleton = styled(SearcherSkeletonDefault).withConfig({
    displayName: "styled__SearcherSkeleton",
    componentId: "sc-83730637-0"
})`
	.searcher-button {
		flex-basis: 20%;
		& > div {
			min-width: 100%;
			max-width: 100%;
		}

		${({ theme  })=>theme.media.between('xs', 'md')} {
			flex-basis: 100%;
			min-width: 100%;
			max-width: 100%;
		}
	}
`;

//# sourceMappingURL=styled.js.map